import { createTriggerStore } from "@utils/createTriggerStore";
import { EnrollmentTriggerPayload } from "./types";

const store = createTriggerStore<EnrollmentTriggerPayload>();

export const openEnrollmentModal = store.open;
export const closeEnrollmentModal = store.close;
export const useEnrollmentTrigger = store.useTrigger;
